import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const SparkleIcon = ({ height, viewBox, width, fill, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                d="M10.1023 7.10631L10.5608 8.38051C11.0708 9.7947 12.1843 10.9081 13.5984 11.4181L14.8726 11.8766C14.9876 11.9181 14.9876 12.0809 14.8726 12.1223L13.5984 12.5809C12.1842 13.0908 11.0708 14.2043 10.5608 15.6184L10.1023 16.8926C10.0608 17.0076 9.89799 17.0076 9.85656 16.8926L9.39803 15.6184C8.88806 14.2043 7.77458 13.0908 6.36044 12.5809L5.08624 12.1223C4.97125 12.0809 4.97125 11.9181 5.08624 11.8766L6.36044 11.4181C7.77463 10.9081 8.88807 9.79464 9.39803 8.38051L9.85656 7.10631C9.89799 6.9906 10.0608 6.9906 10.1023 7.10631Z"
                fill={fill}
            />
            <path
                d="M15.8384 4.04446L16.0712 4.68941C16.3297 5.40507 16.8933 5.96931 17.6096 6.22787L18.2546 6.4607C18.3132 6.48213 18.3132 6.56427 18.2546 6.58498L17.6096 6.81781C16.894 7.07637 16.3297 7.6399 16.0712 8.35628L15.8384 9.00122C15.8169 9.05979 15.7348 9.05979 15.7141 9.00122L15.4812 8.35628C15.2227 7.64061 14.6592 7.07637 13.9428 6.81781L13.2978 6.58498C13.2393 6.56355 13.2393 6.48142 13.2978 6.4607L13.9428 6.22787C14.6584 5.96931 15.2227 5.40579 15.4812 4.68941L15.7141 4.04446C15.7348 3.98518 15.8176 3.98518 15.8384 4.04446Z"
                fill={fill}
            />
            <path
                d="M15.8384 14.9994L16.0712 15.6443C16.3297 16.36 16.8933 16.9242 17.6096 17.1828L18.2546 17.4156C18.3132 17.437 18.3132 17.5192 18.2546 17.5399L17.6096 17.7727C16.894 18.0313 16.3297 18.5948 16.0712 19.3112L15.8384 19.9561C15.8169 20.0147 15.7348 20.0147 15.7141 19.9561L15.4812 19.3112C15.2227 18.5955 14.6592 18.0313 13.9428 17.7727L13.2978 17.5399C13.2393 17.5185 13.2393 17.4363 13.2978 17.4156L13.9428 17.1828C14.6584 16.9242 15.2227 16.3607 15.4812 15.6443L15.7141 14.9994C15.7348 14.9408 15.8176 14.9408 15.8384 14.9994Z"
                fill={fill}
            />
        </SvgIcon>
    );
};

SparkleIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

SparkleIcon.defaultProps = {
    fill: DEFAULT_COLORS.BLACK,
    height: '24',
    viewBox: '0 0 24 24',
    width: '24',
};

export default SparkleIcon;
